import script from "./NoticeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoticeModal.vue?vue&type=script&setup=true&lang=ts"

import "./NoticeModal.vue?vue&type=style&index=0&id=6f08bb25&lang=scss"

const __exports__ = script;

export default __exports__